import styled from 'styled-components';
import theme from '../../theme';

// Define domainOptions from domainIconMapRaw - Assuming domainIconMapRaw is imported if needed here, else adjust path
// import { domainIconMapRaw } from '../Onboarding/domainIconMap';
// const domainOptions = Object.keys(domainIconMapRaw);

// Define formationTypeOptions if needed locally or import them
// const formationTypeOptions = [...];

export const ContentContainer = styled.div`
  padding: 0;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const TopActionContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  max-width: 1100px;
  margin-bottom: 2rem;
  flex-wrap: wrap;
  gap: 1rem;
`;

export const SearchAndAddContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 1.5rem;
  flex-wrap: nowrap;
  flex: 1;
  min-width: 0;
`;

export const ViewToggleContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  position: relative;
`;

export const ViewToggleButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 8px;
  border: 1px solid ${props => props.isActive ? theme.colors.bleu_fonce : '#E6E6E6'};
  background: ${props => props.isActive ? theme.colors.bleu_fonce : '#FFF'};
  cursor: pointer;
  transition: all 0.2s ease;

  img {
    width: 20px;
    height: 20px;
    opacity: ${props => props.isActive ? 1 : 0.6};
  }

  &:hover {
    background: ${props => props.isActive ? theme.colors.bleu_fonce : '#f5f5f5'};
  }
`;

export const SearchWrapper = styled.div`
  position: relative;
  width: 100%;
  max-width: 600px;
  min-width: 200px;
`;

export const SearchInput = styled.input`
  width: 100%;
  height: 51px;
  flex-shrink: 0;
  border-radius: 50px;
  border: 1px solid #E6E6E6;
  background: #FEFFFE;
  padding: 0.5rem 60px 0.5rem 1.5rem;
  font-size: 1rem;
  box-sizing: border-box;
  outline: none;

  &::placeholder {
    color: #aaa;
  }
`;

export const SearchIconWrapper = styled.div`
  position: absolute;
  right: 6px;
  top: 50%;
  transform: translateY(-50%);
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: ${props => props.isActive ? '#38B6FF' : '#E6E6E6'};
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
`;

export const SearchIcon = styled.img`
  width: 20px;
  height: 20px;
`;

export const FormationsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(287px, 1fr));
  gap: 1.5rem;
  padding: 0 2rem 2rem 2rem;
  width: 100%;
  max-width: 1200px;
`;

export const FormationCard = styled.div`
  width: 100%;
  height: 100%;
  flex-shrink: 0;
  border-radius: 20px;
  border: 1px solid #E6E6E6;
  background: #FEFFFE;
  padding: 1.5rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  box-sizing: border-box;
`;

export const CardTopContent = styled.div`
  /* Container for title and establishment info */
`;

export const FormationTitle = styled.h2`
  color: #29435B;
  font-family: 'Gabarito';
  font-size: 1rem;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  margin: 0 0 1rem 0;
`;

export const EstablishmentInfo = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 1rem;
`;

export const LocationIcon = styled.img`
  width: 20px;
  height: 20px;
  margin-right: 0.5rem;
  flex-shrink: 0;
`;

export const EstablishmentName = styled.span`
  color: #29435B;
  font-family: 'Gabarito';
  font-size: 1rem;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
`;

export const ErrorMessage = styled.div`
  color: #e74c3c;
  margin-top: 1rem;
  padding: 1rem;
  background-color: #fde8e8;
  border-radius: 4px;
`;

export const LoadingMessage = styled.div`
  color: #3498db;
  margin-top: 1rem;
  padding: 1rem;
  background-color: #e8f4fd;
  border-radius: 4px;
`;

export const UpdateButton = styled.button`
  width: 235px;
  height: 45px;
  flex-shrink: 0;
  border-radius: 10px;
  background: #38B6FF;
  border: none;
  cursor: pointer;
  color: #FFF;
  font-family: 'Gabarito';
  font-size: 1rem;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  display: flex;
  justify-content: center;
  align-items: center;
  align-self: center;
  transition: background-color 0.2s;
  margin-top: auto;

  &:hover {
    background-color: ${theme.colors.bleu_fonce};
  }
`;

export const AddButton = styled.button`
  height: 51px;
  flex-shrink: 0;
  border-radius: 10px;
  background: #333;
  border: none;
  cursor: pointer;
  color: #FFF;
  font-family: 'Gabarito';
  font-size: 1rem;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 1.5rem;
  transition: background-color 0.2s;
  white-space: nowrap;

  img {
    width: 16px;
    height: 16px;
    margin-right: 0.5rem;
  }

  &:hover {
    background-color: #555;
  }
`;

// Table view styles
export const TableContainer = styled.div`
  width: 100%;
  max-width: ${props => props.isFullScreen ? '100%' : '1200px'};
  overflow-x: auto;
  border-radius: 10px;
  border: 1px solid #E6E6E6;
  background: #FEFFFE;
  margin-bottom: 2rem;
  position: ${props => props.isFullScreen ? 'fixed' : 'relative'};
  top: ${props => props.isFullScreen ? '0' : 'auto'};
  left: ${props => props.isFullScreen ? '0' : 'auto'};
  right: ${props => props.isFullScreen ? '0' : 'auto'};
  bottom: ${props => props.isFullScreen ? '0' : 'auto'};
  z-index: ${props => props.isFullScreen ? '1000' : '1'};
  height: ${props => props.isFullScreen ? '100vh' : 'auto'};
  padding: ${props => props.isFullScreen ? '0' : '0'};
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-family: 'Gabarito';
`;

export const TableHeader = styled.thead`
  background-color: #f5f5f5;
  position: sticky;
  top: 0;
  z-index: 2;
`;

export const TableHeaderRow = styled.tr`
  position: relative;
`;

export const ExpandIcon = styled.img`
  width: 20px;
  height: 20px;
  cursor: pointer;
  position: absolute;
  left: 10px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 3;
`;

export const TableHeaderCell = styled.th`
  padding: 1rem;
  text-align: left;
  font-weight: 600;
  color: #29435B;
  border-bottom: 1px solid #E6E6E6;
  white-space: nowrap;
  position: relative;
  
  &:first-child {
    padding-left: 40px;
  }
`;

export const TableBody = styled.tbody``;

export const TableRow = styled.tr`
  &:hover {
    background-color: #f9f9f9;
  }
`;

export const TableCell = styled.td`
  padding: 1rem;
  padding-left: 1.5rem;
  border-bottom: 1px solid #E6E6E6;
  color: #29435B;
  white-space: nowrap;
`;

export const TypeFinalTableCell = styled(TableCell)`
  min-width: 200px;
  max-width: 300px;
  white-space: normal;
  word-wrap: break-word;
`;

export const TypeFinalHeaderCell = styled(TableHeaderCell)`
  min-width: 200px;
  max-width: 300px;
  white-space: normal;
  word-wrap: break-word;
`;

// Add styled components for the type selection dropdown
export const TypeSelectionDropdown = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  max-height: 300px;
  overflow-y: auto;
  background: white;
  border: 1px solid #E6E6E6;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  z-index: 10;
  padding: 0.5rem;
`;

export const TypeCheckboxGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export const TypeCheckboxItem = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
`;

export const TypeCheckboxLabel = styled.label`
  margin-left: 0.5rem;
  font-size: 0.9rem;
  color: #29435B;
  cursor: pointer;
`;

export const TypeCheckboxInput = styled.input.attrs({ type: 'checkbox' })`
  cursor: pointer;
`;

export const TypeSelectionTrigger = styled.div`
  cursor: pointer;
  position: relative;
  padding: 0.5rem;
  border: 1px solid #E6E6E6;
  border-radius: 4px;
  background: #f9f9f9;
  
  &:hover {
    background: #f0f0f0;
  }
  
  &::after {
    content: '';
    position: absolute;
    right: 0.5rem;
    top: 50%;
    transform: translateY(-50%);
    width: 0;
    height: 0;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-top: 5px solid #29435B;
  }
`;

export const EditableTableCell = styled(TableCell)`
  padding: 0;
  
  span.display-value {
    display: block;
    padding: 1rem;
    padding-left: 1.5rem;
  }

  input, select {
    width: 100%;
    padding: 1rem;
    padding-left: 1.5rem;
    border: none;
    background: transparent;
    font-family: 'Gabarito';
    font-size: 1rem;
    color: #29435B;
    outline: none;
    
    &:focus {
      background-color: #f0f8ff;
    }
  }
  
  select {
    cursor: pointer;
  }
`;

export const SuccessIndicator = styled.div`
  position: absolute;
  top: 50%;
  right: -125px;
  transform: translateY(-50%);
  background-color: #B9FFAA;
  color: #4AE019;
  border-radius: 20px;
  padding: 5px 15px;
  display: flex;
  align-items: center;
  gap: 8px;
  z-index: 1000;
  animation: fadeInOut 2s ease-in-out;
  font-weight: 500;
  font-size: 14px;
  
  img {
    width: 18px;
    height: 18px;
  }
  
  @keyframes fadeInOut {
    0% { opacity: 0; transform: translateY(-50%) scale(0.8); }
    20% { opacity: 1; transform: translateY(-50%) scale(1); }
    80% { opacity: 1; transform: translateY(-50%) scale(1); }
    100% { opacity: 0; transform: translateY(-50%) scale(0.8); }
  }
`;

// Add styled components for the toggle switch
export const ToggleSwitch = styled.div`
  width: 32px;
  height: 12px;
  border-radius: 25px;
  background: ${props => props.isActive ? '#DCF3FF' : '#E6E6E6'};
  position: relative;
  cursor: pointer;
  transition: background-color 0.2s ease;
  
  &:hover {
    background: ${props => props.isActive ? '#C5E8FF' : '#D9D9D9'};
  }
`;

export const ToggleCircle = styled.div`
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: ${props => props.isActive ? '#38B6FF' : '#FFFFFF'};
  position: absolute;
  top: 0;
  left: ${props => props.isActive ? '20px' : '0'};
  transition: left 0.2s ease, background-color 0.2s ease;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
`;

// Add styled components for the domain selection dropdown
export const DomainSelectionDropdown = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  max-height: 300px;
  overflow-y: auto;
  background: white;
  border: 1px solid #E6E6E6;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  z-index: 10;
  padding: 0.5rem;
`;

export const DomainCheckboxGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export const DomainCheckboxItem = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
`;

export const DomainCheckboxLabel = styled.label`
  margin-left: 0.5rem;
  font-size: 0.9rem;
  color: #29435B;
  cursor: pointer;
`;

export const DomainCheckboxInput = styled.input.attrs({ type: 'checkbox' })`
  cursor: pointer;
`;

export const DomainSelectionTrigger = styled.div`
  cursor: pointer;
  position: relative;
  padding: 0.5rem;
  border: 1px solid #E6E6E6;
  border-radius: 4px;
  background: #f9f9f9;
  
  &:hover {
    background: #f0f0f0;
  }
  
  &::after {
    content: '';
    position: absolute;
    right: 0.5rem;
    top: 50%;
    transform: translateY(-50%);
    width: 0;
    height: 0;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-top: 5px solid #29435B;
  }
`;

export const BinaryCell = styled.div`
  cursor: pointer;
  padding: 8px;
  border-radius: 4px;
  background-color: ${props => 
    props.isEditing ? '#f0f0f0' : 
    props.isSaving ? '#e6f7ff' : 
    props.isSuccess ? '#f6ffed' : 'transparent'};
  transition: background-color 0.3s;
`;

export const BinarySelect = styled.select`
  width: 100%;
  padding: 8px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  background-color: white;
`;

export const BinaryValue = styled.span`
  color: ${props => props.isTrue ? '#52c41a' : '#f5222d'};
  font-weight: ${props => props.isTrue ? 'bold' : 'normal'};
`; 